import { get_api, post_api, put_api } from '../../../redux/api_funcs';
import { get_api_url } from '../../../utils/urls';
import { KIND_CANCEL, care_api_error } from './care_request_rules';

// PROD-7828 E1: goserver /v2/cms_user/session_care_requests. Callers upload the screenshot BEFORE the apis booking
// change (a failed upload changes nothing) and save the record AFTER it succeeds.

const BASE = '/v2/cms_user/session_care_requests';
const care_url = (path = '') => get_api_url(`${BASE}${path}`, false, true);

export function upload_care_screenshot(session_uuid, file) {
  const form = new FormData();
  form.append('file', file);
  form.append('session_uuid', session_uuid);
  return post_api(care_url('/screenshot'), form, true, 'formdata').then(
    (res) => res.data.data.screenshot_key
  );
}

export const load_session_care_requests = (session_uuid) =>
  get_api(care_url(`/sessions/${encodeURIComponent(session_uuid)}`), true).then(
    (res) => res.data.data
  );

export const update_care_request = (uuid, body) => put_api(care_url(`/${uuid}`), body, true);

const NOT_READY_RETRIES = 3;
const NOT_READY_DELAY_MS = 1500;
const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

// Saves a record (same uuid on every attempt, so retries never save twice).
// CHANGE_NOT_READY: apis answers a teacher change before it writes the change row, so wait and retry.
// ALREADY_RECORDED on a CANCEL: a session restored and cancelled again keeps its one CANCEL record, which is updated
// to this cancellation instead, so Care is never stuck.
export async function save_care_request(payload, { delay_ms = NOT_READY_DELAY_MS } = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await post_api(care_url(''), payload, true);
      return;
    } catch (e) {
      const err = care_api_error(e, '');
      if (err.code === 'CHANGE_NOT_READY' && attempt < NOT_READY_RETRIES) {
        // eslint-disable-next-line no-await-in-loop
        await sleep(delay_ms);
      } else if (
        err.code === 'ALREADY_RECORDED' &&
        payload.change_kind === KIND_CANCEL &&
        err.existing_uuid
      ) {
        await update_care_request(err.existing_uuid, {
          initiated_by: payload.initiated_by,
          requested_at: payload.requested_at,
          note: payload.note,
          ...(payload.screenshot_key ? { screenshot_key: payload.screenshot_key } : {}),
          edit_note: 'Session cancelled again'
        });
        return;
      } else {
        throw e;
      }
    }
  }
}
